import React, { useState, useEffect, Fragment } from 'react';
import services from '../service';
import { validateProperty, validate } from "../../Common";
import { BuyerFilteringSchemaObject } from '../BuyerSchema';
import { BuyerListing } from '../Pages/listing';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { TextField } from '@material-ui/core';

const screenCode = 'BUYER';

export function BuyerFiltering(props) {

    const { data, edit } = props.location;
    const [groups, setGroups] = useState();
    const [operationEntity, setOperationEntity] = useState();
    const [buyerFilteringData, setBuyerFilteringData] = useState([]);
    const [buyerFiltering, setBuyerFiltering] = useState({
        groupID: '0',
        operationEntityID: '0',
        businessRegNo: '',
    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Completed successfuly."
    });
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(BuyerFilteringSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        trackPromise(
            getPermissions(),
            getGroupsForDropdown()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown(),
            handleSearch()
        )
    }, [buyerFiltering.groupID])

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWBUYERLISTING');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITBUYER');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        }
        );

        var token = tokenService.getUserDetailsFromToken();
        setBuyerFiltering({
            ...buyerFiltering,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropdown();
    }

    async function getOperationEntitiesForDropdown() {
        const operationEntities = await services.getAllOperationEntitiesForDropDown(buyerFiltering.groupID);
        setOperationEntity(operationEntities);
    }

    function handleChange(e) {
        const target = e.target;

        const value = target.value;

        setBuyerFiltering({
            ...buyerFiltering,
            [e.target.name]: value
        });

        setErrors('');
    }

    async function handleSearch(e) {

        if(e !== undefined)
            e.preventDefault();

        const errorMessages = validate(schema, buyerFiltering);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        const response = await services.getAllBuyersByFilter(buyerFiltering);
        setBuyerFilteringData(response);
    }

    async function editBuyerFiltering(data) {
        props.history.push({
            pathname: 'buyer/AddEdit',
            data: data,
            edit: true
        });
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setBuyerFiltering({
            ...buyerFiltering,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            businessRegNo: '',
        });
        setBuyerFilteringData([]);
        setErrors('');
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }
    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title="Buyer Listing"
                                    isButtonEnable={permissionList.isAddEditEnabled
                                    }
                                    path="buyer/AddEdit"
                                    buttonText="Add Buyer"
                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => handleSearch(e)} disabled={false}>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            id="groupID"
                                            name="groupID"
                                            value={buyerFiltering.groupID}
                                            onChange={(e) => handleChange(e)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)
                                            }
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        }
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            value={buyerFiltering.operationEntityID}
                                            onChange={(e) => handleChange(e)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)
                                            }
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>
                                        }
                                    </div>
                                    <div className="col-md">

                                        <TextField
                                            fullWidth
                                            label="Business RegNo"
                                            id="businessRegNo"
                                            name="businessRegNo"
                                            type="text"
                                            value={buyerFiltering.businessRegNo}
                                            onChange={(e) => handleChange(e)}
                                        >
                                        </TextField>

                                    </div>

                                </div>

                                <div className="card-footer">
                                    <input
                                        type="submit"
                                        className="btn btn-primary"
                                        value="Search"
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>


                                <BuyerListing
                                    buyerFilteringData={buyerFilteringData}
                                    handleClick={editBuyerFiltering}
                                    editEnabled={permissionList.isAddEditEnabled
                                    }

                                />


                            </form>

                        </div>
                    </div>
                </div>
            </div>

            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />

        </Fragment>
    );
}